// @flow
import React, { lazy } from 'react'
import { PrivateRoute } from 'src/common/components'
const PublicLeaguesList = lazy(() => import('src/modules/leagueFinder/publicLeaguesList'))

export default [
  <PrivateRoute exact={true} path="/league-finder" component={PublicLeaguesList} key="league-finder"/>,
]
